import { render, staticRenderFns } from "./Git.vue?vue&type=template&id=69ad0561&scoped=true&"
import script from "./Git.vue?vue&type=script&lang=js&"
export * from "./Git.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ad0561",
  null
  
)

export default component.exports